// Accounting Income Types Vuex

import state from './payrollStates.js'
import * as getters from './payrollGetters.js'
import * as mutations from './payrollMutations.js'
import * as actions from './payrollActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
